export default __webpack_public_path__ + "static/media/1_1.24304f6b.jpg";